import React, { useState } from 'react';
import { RefreshCw, Trash2, CheckCircle } from 'lucide-react';
import { adminApi } from '@/services/api';
import { Button } from '@/components/ui/Button';
import { useToast } from '@/components/ui/Toast';

interface CleanupResult {
  oldActions: number;
}

export const CleanupTab: React.FC = () => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<CleanupResult | null>(null);

  const handleCleanup = async () => {
    if (!confirm('确定要清理过期数据吗？此操作不可撤销。')) return;
    setLoading(true);
    try {
      setResult(await adminApi.cleanup());
      toast.success('数据清理完成');
    } catch {
      toast.error('清理失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-xl p-5">
        <div className="flex items-start gap-3">
          <div>
            <p className="text-sm text-orange-600 dark:text-orange-400/80 mb-2">
              以下数据根据动态配置的保留天数清理：
            </p>
            <ul className="text-sm text-orange-600 dark:text-orange-400/80 space-y-1">
              <li>• 用户行为日志（默认保留90天）</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="flex justify-center">
        <Button variant="primary" onClick={handleCleanup} disabled={loading}>
          {loading ? <RefreshCw className="w-4 h-4 mr-2 animate-spin" /> : <Trash2 className="w-4 h-4 mr-2" />}
          {loading ? '清理中...' : '执行清理'}
        </Button>
      </div>

      {result && (
        <div className="bg-white dark:bg-surface-800 rounded-xl border border-surface-200 dark:border-surface-700 p-5">
          <h3 className="font-semibold text-surface-900 dark:text-surface-100 mb-4 flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-green-500" />
            清理结果
          </h3>
          <div className="grid grid-cols-1 gap-3">
            {[
              ['用户行为日志', result.oldActions],
            ].map(([label, value]) => (
              <div key={label as string} className="bg-surface-50 dark:bg-surface-900 rounded-lg p-3 text-center">
                <div className="text-xl font-bold text-surface-900 dark:text-surface-100">{value as number}</div>
                <div className="text-xs text-surface-500 mt-0.5">{label as string}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
